<template>
  <div class="m-switch">
    <v-switch v-model="val" hide-details class="switch"></v-switch>
    <span>{{label}}</span>
  </div>
</template>
<script>
  export default {
    name: 'mSwitch',
    computed: {
      val: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    props: {
      value: Boolean,
      label: String
    }
  }
</script>
<style lang="scss" scoped>
  .m-switch {
    display: inline-block;
    margin-right: 8px;
    color: rgba(0,0,0,.54);
    .switch {
      display: inline-flex;
      width: 42px;
      flex: auto;
      vertical-align: middle;
    }
  }
</style>



// WEBPACK FOOTER //
// src/admin/components/mSwitch.vue